<script setup>
  import { computed } from 'vue';
  import { useDateHelper } from "@/composables/useDateHelper";
  import { useSpotStore } from "@/stores/SpotStore";
  import { useCompleteReportStore } from '@/stores/CompleteReportStore';
  import { format } from 'date-fns';

  const dateHelper = useDateHelper();

  const spotStore = useSpotStore();
  const completeReportStore = useCompleteReportStore();

  const apiData = computed(() => spotStore.stationApiDataValues);
  
  const timestamp = computed(() => {
    if (!apiData.value.timestamp) return 'N/A';

    const localTimezone = spotStore.localTimezoneShort ?  ` ${spotStore.localTimezoneShort}` : '';
    let apiTimestamp;
    let relativeTimestamp = 'N/A';

    try {
      apiTimestamp = dateHelper.dateTimeToISODate(apiData.value.timestamp, spotStore.localUTCOffset);

      relativeTimestamp = completeReportStore.lastUpdateTime === 'timestamp' 
        ? `${format(apiTimestamp, 'd LLL p')}${localTimezone}` 
        : dateHelper.timeFromNow(apiTimestamp);
    } catch (e) {
      console.warn('Error parsing api timestamp: ', apiData.value.timestamp, e);
    }

    return relativeTimestamp;
  });
</script>

<template>
  <div>
    <p class="jwx-complete-report__last-update">Last Update: <span v-html="timestamp" class="jwx-complete-report__last-update-time"></span></p>
  </div>
</template>